<section [class]="'svg-wrapper ' + classes">
  <svg-icon
    [src]="'assets/icons/' + icon + '.svg'"
    [class]="'svg-icon'"
    [svgStyle]="styles"
  ></svg-icon>
</section>
